// extracted by mini-css-extract-plugin
export default {"sectionContent":"SectionContent_sectionContent__x5nC+"};